import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'wilson-filter-label',
  template: `
    <ng-content></ng-content>
    @if (label) {
      <span class="label"> {{ label }} </span>
    }
  `,
  styleUrls: ['./filter-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FilterLabelComponent {
  @Input()
  label!: string;
}
